import {ChatAnamGame} from "./Anam/ChatAnamGame";
import {ChatHeygenGame} from "./Heygen/ChatHeygenGame";
import {
  ANAM_AVATAR_ID,
  ANAM_PERSONA_ID,
  ANAM_VOICE_ID,
} from "@hooks/AnamAvatar/utils";
import {useEffect, useMemo} from "react";
import {useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";

const strTrim = (v) => (typeof v === "string" ? v.trim() : "");

/** Если history пустая (новая вкладка / прямой заход) — не назад, а сюда */
const CHAT_BOOTSTRAP_FALLBACK_PATH = "/simulations/call";

const hasInlineAnamPersonaConfig = (reduxAvatarId, reduxVoiceId) => {
  if (strTrim(ANAM_PERSONA_ID)) return true;
  const avatar =
    strTrim(ANAM_AVATAR_ID) || strTrim(String(reduxAvatarId ?? ""));
  const voice =
    strTrim(ANAM_VOICE_ID) || strTrim(String(reduxVoiceId ?? ""));
  return Boolean(avatar && voice);
};

/**
 * Один роут /chat/... — движок задаётся при переходе с карточки (state.chatAvatarProvider).
 * После F5 state и Redux пустые — уходим назад, без данных аватар не стартовать.
 */
export const ChatGameEntry = () => {
  const {state: routeState} = useLocation();
  const navigate = useNavigate();
  const {avatarId, voiceId} = useSelector((state) => state.ml.chat);

  const bootstrapInvalid = useMemo(() => {
    if (
      !routeState ||
      typeof routeState !== "object" ||
      !routeState.level ||
      !routeState.desc ||
      !routeState.chatAvatarProvider
    ) {
      return true;
    }
    if (routeState.chatAvatarProvider === "heygen") {
      return (
        !strTrim(String(avatarId ?? "")) || !strTrim(String(voiceId ?? ""))
      );
    }
    if (routeState.chatAvatarProvider === "anam") {
      return !hasInlineAnamPersonaConfig(avatarId, voiceId);
    }
    return true;
  }, [routeState, avatarId, voiceId]);

  useEffect(() => {
    if (!bootstrapInvalid) return;
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(CHAT_BOOTSTRAP_FALLBACK_PATH, {replace: true});
    }
  }, [bootstrapInvalid, navigate]);

  if (bootstrapInvalid) {
    return null;
  }

  const useAnam = routeState.chatAvatarProvider === "anam";
  return useAnam ? <ChatAnamGame /> : <ChatHeygenGame />;
};
